import { render } from "./dynamic-yield-observer.vue?vue&type=template&id=44e567dc"
import script from "./dynamic-yield-observer.vue?vue&type=script&lang=js"
export * from "./dynamic-yield-observer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__